import jwtDecode, { JwtPayload } from 'jwt-decode';

export const isExpired = (
    expiryDate: Date | string | number | undefined,
    bufferInMinutes: number = 0,
) => {
    // Converting minutes to milliseconds for comparison.
    const buffer = bufferInMinutes * 60000;

    if (!expiryDate) return false;

    const currentTime = new Date().getTime();
    const expiryTime = new Date(expiryDate).getTime();

    // If expiryTime is beyond current time, token is expired.
    if (currentTime >= expiryTime) return true;

    const diffInMs = expiryTime - currentTime;

    // Lastly, if the remaining time is less than the buffer, we should get a new token.
    return diffInMs <= buffer;
};

export const isJwtExpired = (token: string, bufferInMinutes = 10): boolean => {
    const { exp } = jwtDecode<JwtPayload>(token);

    const hasExpired = isExpired(
        exp && exp * 1000,
        // We will introduce a buffer of 10 minutes (converted to ms).
        bufferInMinutes,
    );

    if (hasExpired) console.log('JWT: Token is expired.');

    return hasExpired;
};

export const isJwtValid = (token: string): boolean => {
    try {
        const parsed = jwtDecode(token);
        /**
         * We'll check the validity of a JWT by trying to decode it. If we encounter a runtime
         * error, that means that it's invalid.
         */
        return !!parsed;
    } catch (error) {
        console.log('JWT: Token is invalid.');

        return false;
    }
};

export const isJwtUsable = (
    token: string | null | undefined,
    bufferInMinutes: number,
): token is string => !!token && isJwtValid(token) && !isJwtExpired(token, bufferInMinutes);
